import { v4 as uuid } from "uuid"
import { findAllSubstringIndices, getMatchingEndStart, getMatchingStart } from "./replaceHelpers"
import { escapeRegExp } from "@editor/utils/escapeRegExp"

export const getSearchNodesBySearchValue = (textNodes, searchValue) => {
  const searchData = []
  let bufferText = ""
  let bufferNodesData = []
  let prevIsMatching = ""
  let index = 0
  for (const node of textNodes) {
    index++
    const text = node.getTextContent()
    if (bufferText) {
      bufferText = escapeRegExp(bufferText)
      const isMatchingFirst = getMatchingStart(
        text,
        searchValue.replace(new RegExp(bufferText, "i"), ""),
      )

      if (isMatchingFirst.length) {
        bufferText = bufferText + isMatchingFirst
        bufferNodesData.push({ node: node, matchText: isMatchingFirst })
      }
      //добавляем ноду состоящую из нескольких кусочков
      // но проверяем bufferNodesData
      // если он равен 1, то не добавляем
      //т.к создастся дубль. такие ноды добавляются выше
      if (bufferText.toLowerCase() === searchValue.toLowerCase() && bufferNodesData.length >= 2) {
        let matchTextFull = ""
        let keyOrders = null
        bufferNodesData.map((item, i) => {
          matchTextFull += item.matchText
          const currentKey = Number(item.node.__key)

          if (i === 0) {
            keyOrders = currentKey
          } else {
            keyOrders = keyOrders === currentKey - 1 ? currentKey : null
          }

          return undefined
        })

        if (
          searchValue.toLowerCase() === matchTextFull.toLowerCase() &&
          matchTextFull.trim().length &&
          keyOrders
        ) {
          keyOrders = null
          searchData.push({
            startIndex: null,
            endIndex: null,
            nodesData: bufferNodesData,
            id: uuid(),
          })
        }

        bufferText = ""
        bufferNodesData = []
      }
    }
    const allIndices = findAllSubstringIndices(text, searchValue, node)
    if (allIndices[0]?.nodesData?.length) {
      searchData.push(...allIndices)
    }

    const nextNode = textNodes[index] || []
    const isMatching = getMatchingEndStart(text, searchValue)
    bufferText = escapeRegExp(bufferText)
    const bufferisMatchingFirst = getMatchingStart(
      nextNode?.__text || "$",
      searchValue.replace(new RegExp(bufferText, "i"), ""),
    )

    if (isMatching.length && !bufferisMatchingFirst.length) {
      prevIsMatching = isMatching
      if (searchValue) {
        bufferText = isMatching
        prevIsMatching = isMatching
        bufferNodesData = []
        bufferNodesData.push({ node: node, matchText: isMatching })
      }
    }
  }

  return searchData
}
